<template>
  <li>
    <h4>{{title}}</h4>
    <div ref="queryString" class="query-string" :class="{isOpen: isOpen}" :style="queryStringMaxHeight">

      <span ref="content">{{queryString}}</span>

      <span v-if="showMore" class="showMore" @click="isOpen = !isOpen">
        <span class="dots">...</span>
        <i class="fas fa-chevron-circle-down"/>
        <span class="show-more-btn">show more</span>
      </span>
    </div>
  </li>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: "QueriesListItem",
  props: {
    query: {
      type: Object,
      required: true
    }
  },

  mounted() {
    //contentRef will be used to calculate the maxHeight of each query preview and maintain open animation for lengthy queries
    this.contentRef = this.$refs.content
    this.getContentHeight()
    this.setShowMore()
  },

  data() {
    return {
      showMore: false,
      isOpen: false,
      contentRef: null,
      contentHeight: 0
    }
  },

  computed: {
    ...mapState({
      isResizing: state => state.booleanSearch.isResizing,
    }),

    key() { return Object.keys(this.query)[0] },
    title() { return this.$t(`booleanSearch.queries.fields.${this.key}.title`) },
    queryString() { return this.query[this.key] },
    queryStringMaxHeight() { return { maxHeight: !this.isOpen ? 3.4 + 'rem' : this.contentHeight } }
  },

  methods: {
    setShowMore() {
      this.showMore = this.isOverFlown(this.$refs.queryString)
    },
    getContentHeight() {
      this.$nextTick(() => this.contentHeight = this.contentRef ? this.contentRef.offsetHeight + 40 + 'px' : 3.4 + 'rem' )
    },
    isOverFlown(ref) {
      return (ref.offsetHeight + 20 < ref.scrollHeight);
    }
  },

  watch: {
    isResizing(newVal) { // check showMore button on resize
      if(newVal) {
        this.setShowMore()
        this.getContentHeight()
      }
    }
  },
}
</script>
